import Multiselect from 'vue-multiselect'
import DateMixin from '@/shared/mixins/date.mixin'
import RadioExamsMixin from '@/shared/mixins/radio-report.mixin'

export default {
  components: {
    Multiselect
  },
  mixins: [
    DateMixin,
    RadioExamsMixin
  ],
  props: {
    open: Boolean,
    examDetail: Object,
    bodyPartsSelecteds: Array,
    initialSubSpecialties: Array
  },
  data() {
    return {
      titleNewErrorIndexes: [],
      subSpecialties: [],
      filteredOptions: [],
      showAutocomplete: [],
      notFoundMsg: this.$t('radio_report.specialty_not_registered'),
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscapeKey);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscapeKey);
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.titleNewErrorIndexes = [];
        this.showAutocomplete = [];
        this.filteredOptions = [];
        this.subSpecialties = this.initialSubSpecialties || [];
        this.initializeAndValidateExams();
      }
    },
  },
  methods: {
    initializeAndValidateExams() {
      const newErrorIndexes = [];
      this.bodyPartsSelecteds.forEach((part, index) => {
        if (index === 0) {
          if (!part.selectedItems || !Array.isArray(part.selectedItems)) {
            this.$set(part, 'selectedItems', []);
          }

          let namesFromString = [];
          if (part.titleNew && typeof part.titleNew === 'string' && part.titleNew.trim() !== '') {
            namesFromString = part.titleNew.split(',').map(name => name.trim()).filter(Boolean);
          }

          const resolvedItems = [];
          let allNamesFound = true;

          if (namesFromString.length > 0) {
            namesFromString.forEach(name => {
              const specialtyObject = this.subSpecialties.find(s => s.name === name);
              if (specialtyObject) {
                if (!resolvedItems.some(item => item.specialityId === specialtyObject.specialityId)) {
                  resolvedItems.push(specialtyObject);
                }
              } else {
                allNamesFound = false;
              }
            });
          }
          part.titleNew = part.selectedItems.map(s => s.name).join(', ');

          if (!allNamesFound && namesFromString.length > 0) {
            if (!newErrorIndexes.includes(index)) {
              newErrorIndexes.push(index);
            }
          } else if ((!part.selectedItems || part.selectedItems.length === 0) && namesFromString.length > 0 && !allNamesFound) {
            if (!newErrorIndexes.includes(index)) {
              newErrorIndexes.push(index);
            }
          }
        } else {
          const title = part.titleNew ? part.titleNew.trim() : '';
          if (title !== '' && !this.subSpecialties.some(s => s.name === title)) {
            if (!newErrorIndexes.includes(index)) {
              newErrorIndexes.push(index);
            }
          }
        }
      });
      this.titleNewErrorIndexes = [...new Set([...this.titleNewErrorIndexes, ...newErrorIndexes])];
    },

    filterOptions(index, event) {
      const searchTerm = event.target.value.toLowerCase().trim();
      this.bodyPartsSelecteds[index].titleNew = event.target.value;
      this.clearTitleNewError(index);

      this.updateFilteredOptions(index, searchTerm);
    },

    updateFilteredOptions(index, searchTerm = '') {
      const matches = this.subSpecialties
        .filter(optionObj => optionObj.name.toLowerCase().includes(searchTerm))
        .map(optionObj => ({ text: optionObj.name, disabled: false }));

      if (matches.length === 0 && searchTerm !== '') {
        matches.push({ text: this.notFoundMsg, disabled: true });
      }
      this.$set(this.filteredOptions, index, matches);
    },

    initializeAutocomplete(index) {
      this.updateFilteredOptions(index);
      this.$set(this.showAutocomplete, index, true);
    },

    selectOption(index, optionText) {
      if (optionText === this.notFoundMsg) return;
      this.bodyPartsSelecteds[index].titleNew = optionText;
      this.$set(this.showAutocomplete, index, false);
      this.clearTitleNewError(index);
      if (!this.subSpecialties.some(s => s.name === optionText)) {
          if(!this.titleNewErrorIndexes.includes(index)) this.titleNewErrorIndexes.push(index);
      }
    },

    onMultiSelectChange(selectedValues) {
      if (this.bodyPartsSelecteds[0]) {
         this.bodyPartsSelecteds[0].selectedItems = selectedValues;
         this.bodyPartsSelecteds[0].titleNew = selectedValues.map(s => s.name).join(', ');
      }
      if (!selectedValues || selectedValues.length === 0) {
        if (!this.titleNewErrorIndexes.includes(0)) {
          this.titleNewErrorIndexes.push(0);
        }
      } else {
        this.clearTitleNewError(0);
      }
    },

    onConfirm() {
      const newErrorIndexes = [];
      this.bodyPartsSelecteds.forEach((part, index) => {
        const title = part.titleNew ? part.titleNew.trim() : '';
        if (title === '') {
          if (index === 0) { // For multiselect, check selectedItems
            if (!part.selectedItems || part.selectedItems.length === 0) {
              if (!newErrorIndexes.includes(index)) newErrorIndexes.push(index);
            }
          } else { // For regular inputs
            if (!newErrorIndexes.includes(index)) newErrorIndexes.push(index);
          }
        } else {
          if (index === 0) {
            if (!part.selectedItems || part.selectedItems.length === 0) {
              if (!newErrorIndexes.includes(index)) newErrorIndexes.push(index);
            }
          } else {
            if (!this.subSpecialties.some(s => s.name === title)) {
              if (!newErrorIndexes.includes(index)) newErrorIndexes.push(index);
            }
          }
        }
      });
      this.titleNewErrorIndexes = [...new Set(newErrorIndexes)];
      if (this.titleNewErrorIndexes.length > 0) {
        return;
      }
      localStorage.removeItem('savedReports');
      this.$emit('onConfirm', this.bodyPartsSelecteds);
    },

    onCancel() {
      this.titleNewErrorIndexes = [];
      this.$emit('onCancel')
    },

    handleSelectBodyPart(bodyPartName) {
      if (this.isBodyPartSelected(bodyPartName)) return;

      const partObj = {
        titleOriginal: bodyPartName,
        titleNew: '',
        examId: null
      };

      if (this.bodyPartsSelecteds.length === 0 || (this.bodyPartsSelecteds.length === 1 && this.bodyPartsSelecteds[0].titleOriginal === '' && this.bodyPartsSelecteds[0].titleNew === '')) {
        this.$set(partObj, 'selectedItems', []);
        partObj.examId = this.examDetail.examId;
        this.bodyPartsSelecteds.splice(0, 1, partObj);

      } else {
        if(this.bodyPartsSelecteds.length > 0 && this.bodyPartsSelecteds[0]){
            const originalExam = this.bodyPartsSelecteds[0];
            if (originalExam.titleOriginal) {
              originalExam.titleOriginal = originalExam.titleOriginal.split(',').map(p=>p.trim()).filter(p => p.toLowerCase() !== bodyPartName.toLowerCase()).join(', ');
            }
            if(originalExam.selectedItems){
                originalExam.selectedItems = originalExam.selectedItems.filter(item => item.name.toLowerCase() !== bodyPartName.toLowerCase());
                originalExam.titleNew = originalExam.selectedItems.map(s => s.name).join(', ');
            }
            if(originalExam.titleOriginal && originalExam.titleOriginal.trim() === '' && (!originalExam.selectedItems || originalExam.selectedItems.length === 0)){
                this.bodyPartsSelecteds.splice(0,1);
            }
        }
        this.bodyPartsSelecteds.push(partObj);
      }
      this.initializeAndValidateExams();
    },

    handleRemoveBodyPart(_partObjAtRemovedIndex, index) {
      if (index < 0 || index >= this.bodyPartsSelecteds.length) return;

      const removedPart = this.bodyPartsSelecteds.splice(index, 1)[0];
      this.titleNewErrorIndexes = this.titleNewErrorIndexes
        .map(errIdx => (errIdx > index ? errIdx - 1 : errIdx))
        .filter(errIdx => errIdx !== index && errIdx < this.bodyPartsSelecteds.length);

      if (this.bodyPartsSelecteds.length === 0) {
        this.bodyPartsSelecteds.push({
          titleOriginal: '',
          titleNew: '',
          selectedItems: [],
          examId: this.examDetail.examId
        });
      } else {
        if (index > 0 && this.bodyPartsSelecteds[0]) {
          const originalExam = this.bodyPartsSelecteds[0];
          if (removedPart.titleOriginal && removedPart.titleOriginal.trim() !== '') {
            const currentOriginalTitles = originalExam.titleOriginal ? originalExam.titleOriginal.split(',').map(t => t.trim()).filter(Boolean) : [];
            const removedTitle = removedPart.titleOriginal.trim();
            if (removedTitle && !currentOriginalTitles.includes(removedTitle)) {
              currentOriginalTitles.push(removedTitle);
            }
            originalExam.titleOriginal = currentOriginalTitles.join(', ');
          }
          this.$set(originalExam, 'selectedItems', []);
          originalExam.titleNew = '';
          this.clearTitleNewError(0);
        }
        else if (index === 0 && this.bodyPartsSelecteds.length > 0) {
          const newOriginalExam = this.bodyPartsSelecteds[0];
          newOriginalExam.examId = removedPart.examId || this.examDetail.examId;

          if (!Object.prototype.hasOwnProperty.call(newOriginalExam, 'selectedItems')) {
            this.$set(newOriginalExam, 'selectedItems', []);
          }
          newOriginalExam.selectedItems = [];
          newOriginalExam.titleNew = '';
        }
      }
      this.initializeAndValidateExams();
    },

    isBodyPartSelected(partName) {
      return this.bodyPartsSelecteds.some(
        (p) => p.titleOriginal && p.titleOriginal.trim().toLowerCase() === partName.trim().toLowerCase()
      );
    },

    examPosition(index) {
      if (index === 0) {
        return `${this.$t('radio_report.original_exam')}:`
      }
      return `${this.$t('radio_report.new_exam')} ${index}:`;
    },

    disableRemoveButton() {
      return this.bodyPartsSelecteds.length === 1;
    },

    clearTitleNewError(index) {
      this.titleNewErrorIndexes = this.titleNewErrorIndexes.filter(i => i !== index);
    },

    handleAddNewExam() {
      this.bodyPartsSelecteds.push({
        titleOriginal: '',
        titleNew: '',
        examId: null
      });
    },

    isDuplicateButtonDisabled() {
      const noAnatomicalRegions =
        (!this.examDetail.titleReport || this.examDetail.titleReport.trim() === '') &&
        (!this.examDetail.bodyParts || this.examDetail.bodyParts.length === 0);

      if (noAnatomicalRegions) {
        const filledCount = this.bodyPartsSelecteds.filter(
          (p) => (p.titleNew && p.titleNew.trim() !== '') || (p.selectedItems && p.selectedItems.length > 0)
        ).length;
        return filledCount < 1 ;
      }

      const isAnyTitleNewFilled = this.bodyPartsSelecteds.some(p => (p.titleNew && p.titleNew.trim() !== '') || (p.selectedItems && p.selectedItems.length > 0) );
      if (!isAnyTitleNewFilled) {
        return true;
      }

      return false;
    },

    splitTitleReport(titleReport) {
      if (typeof titleReport !== 'string') return []
      return titleReport.includes(',')
        ? titleReport.split(',').map(p => p.trim()).filter(Boolean)
        : [titleReport.trim()].filter(Boolean)
    },

    handleClickOutside(event) {
      this.showAutocomplete.forEach((isOpen, i) => {
        if (i === 0) return;
        const autocompleteListRef = this.$refs[`autocomplete-list-${i}`];
        const inputRef = this.$refs[`input-bodypart-${i}`];

        let clickedOutside = true;

        if (autocompleteListRef && Array.isArray(autocompleteListRef) && autocompleteListRef[0] && typeof autocompleteListRef[0].contains === 'function' && autocompleteListRef[0].contains(event.target)) {
          clickedOutside = false;
        }

        if (inputRef && Array.isArray(inputRef) && inputRef[0]) {
            const actualInputRef = inputRef[0];
            if (typeof actualInputRef.contains === 'function' && actualInputRef.contains(event.target)) {
                 clickedOutside = false;
            } else if (actualInputRef.$el && typeof actualInputRef.$el.contains === 'function' && actualInputRef.$el.contains(event.target)) {
                 clickedOutside = false;
            }
        }

        if (isOpen && clickedOutside) {
          if (this.showAutocomplete[i]) {
             this.$set(this.showAutocomplete, i, false);
          }
          const part = this.bodyPartsSelecteds[i];
          if (part && part.titleNew && part.titleNew.trim() !== '' && this.isInvalidSpecialty(part.titleNew)) {
            if (!this.titleNewErrorIndexes.includes(i)) {
              this.titleNewErrorIndexes.push(i);
            }
          }
        }
      });
    },

    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.showAutocomplete.forEach((isOpen, i) => {
          if (i === 0) return;
          if (isOpen) {
            this.$set(this.showAutocomplete, i, false);
            const part = this.bodyPartsSelecteds[i];
            if (part && part.titleNew && part.titleNew.trim() !== '' && this.isInvalidSpecialty(part.titleNew)) {
              if (!this.titleNewErrorIndexes.includes(i)) {
                this.titleNewErrorIndexes.push(i);
              }
            }
          }
        });
      }
    },

    isInvalidSpecialty(title) {
      if (!title || title.trim() === '') return false;
      const normalizedTitle = title.trim().toLowerCase();
      return !this.subSpecialties.some(sObj => sObj.name.toLowerCase() === normalizedTitle);
    },

    getTitleNewErrorMessage(index) {
        const part = this.bodyPartsSelecteds[index];
        if (!part) return this.$t('radio_report.bodypart_error');

        if (index === 0) {
             if (!part.selectedItems || part.selectedItems.length === 0) {
                return this.$t('radio_report.bodypart_error_multiselect');
             }
        } else {
            const title = part.titleNew ? part.titleNew.trim() : '';
            if (title === '') {
                return this.$t('radio_report.bodypart_error');
            }
            if (this.isInvalidSpecialty(title)) {
                return this.$t('radio_report.please_select_valid');
            }
        }
        return '';
    },
    limitText (count) {
      return `${this.$t('radio_report.and_more')} ${count}`
    },
  }
}
